import React from 'react';
import { componentService } from 'js/services/component.service';

export const QuickDeposit = React.lazy(() => import(/* webpackChunkName: "quick-deposit" */ './QuickDeposit'));

// <hub2-quick-deposit></hub2-quick-deposit>
componentService.registerWebContentComponents({ QuickDeposit });
componentService.registerPageComponents({ 'quick-deposit': QuickDeposit });
